import React from "react";
import "./Certifications.css";
import { motion } from "framer-motion";
import { FaCertificate, FaExternalLinkAlt, FaAward } from "react-icons/fa";
import { portfolioData } from "../../data/portfolioData";
const Certifications = () => {
    const certificationsData = portfolioData.certificationsData;
    return (
        <section className="cert-section" id="certifications">
            <div className="cert-container">

                {/* Section Header */}
                <motion.div
                    className="cert-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                >
                    <span className="cert-subtitle">CREDENTIALS</span>
                    <h2 className="cert-title">Certifications</h2>
                    <p className="cert-description">
                        Verified professional certifications and technical specializations.
                    </p>
                </motion.div>

                {/* Certifications Split Grid */}
                <div className="cert-grid">
                    {certificationsData.map((cert, index) => (
                        <motion.div
                            key={cert.id}
                            className="cert-card"
                        /* framer-motion props... */
                        >
                            <div className="cert-icon-box">
                                <FaCertificate className="cert-badge-icon" />
                            </div>

                            {/* This container expands and pins the link right to the bottom line */}
                            <div className="cert-info-box">
                                <div className="cert-meta">
                                    <span className="cert-issuer">{cert.issuer}</span>
                                    <span className="cert-date">{cert.date}</span>
                                </div>

                                <h3 className="cert-card-title">{cert.title}</h3>
                                <p className="cert-card-desc">{cert.description}</p>

                                <a href={cert.credentialUrl} target="_blank" rel="noreferrer" className="cert-verify-btn">
                                    Verify Credential <FaExternalLinkAlt className="cert-link-icon" />
                                </a>
                            </div>

                            <div className="cert-corner-award">
                                <FaAward />
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Certifications;
